import type { SimulationTemplateData } from "./types"

interface NamedLaunchRecord {
  id: string
  display_name?: string | null
}

interface BuildLaunchDisplayNameParams {
  runDisplayName?: string
  isMultiRun: boolean
  agents?: NamedLaunchRecord[]
  personaRecords: NamedLaunchRecord[]
  testSetRecords: NamedLaunchRecord[]
  testSetIds?: string[]
  agentId: string
  personaId: string
  testSetId?: string
}

export function isMultiRunTemplate(
  templateData: Pick<
    SimulationTemplateData,
    "agentIds" | "personaIds" | "testSetIds"
  >,
): boolean {
  const agentCount = templateData.agentIds?.length || 0
  const personaCount = templateData.personaIds?.length || 0
  const testSetCount = templateData.testSetIds?.length || 0

  return agentCount > 1 || personaCount > 1 || testSetCount > 1
}

export function buildLaunchDisplayName({
  runDisplayName,
  isMultiRun,
  agents,
  personaRecords,
  testSetRecords,
  testSetIds,
  agentId,
  personaId,
  testSetId,
}: BuildLaunchDisplayNameParams): string | undefined {
  if (!runDisplayName?.trim()) {
    return undefined
  }

  const baseName = runDisplayName.trim()
  if (!isMultiRun) {
    return baseName
  }

  const agent = agents?.find((record) => record.id === agentId)
  const persona = personaRecords.find((record) => record.id === personaId)
  const agentName = agent?.display_name || agentId.slice(0, 8)
  const personaName = persona?.display_name || personaId.slice(0, 8)
  const parts = [agentName, personaName]

  if ((testSetIds?.length || 0) > 1 && testSetId) {
    const testSet = testSetRecords.find((record) => record.id === testSetId)
    parts.push(testSet?.display_name || testSetId.slice(0, 8))
  }

  return `${baseName} (${parts.join(", ")})`
}
